export {}

document.querySelectorAll(".base-header__toggle").forEach((toggle) => {
  const togglers = toggle.querySelectorAll(".base-header__toggle-button")

  togglers.forEach((togglerButton) => {
    togglerButton.addEventListener("click", () => {
      toggle.classList.toggle("--open")
    })
  })
})
